<template>
  <div class="wolt-menu-layout" :class="{ 'wolt-menu-layout--product': !!selectedProduct }">
    <product-options-panel
      v-if="selectedProduct"
      :product="selectedProduct"
      :currency="currency"
      variant="wolt"
      @close="selectedProduct = null"
    />
    <template v-else>
      <div class="wolt-menu-layout__tabs">
        <button
          v-for="category in categories"
          :key="category.id"
          type="button"
          class="wolt-menu-layout__tab"
          :class="{ 'is-active': category.id === activeCategoryId }"
          @click="selectCategory(category.id)"
        >
          {{ category.name }}
        </button>
      </div>
      <div class="wolt-menu-layout__content" ref="content">
        <section
          v-for="category in categories"
          :key="'sec-' + category.id"
          :id="'wolt-cat-' + category.id"
          class="wolt-menu-layout__section"
        >
          <h2>{{ category.name }}</h2>
          <div class="wolt-menu-layout__grid">
            <article
              v-for="product in category.products"
              :key="product.id"
              class="wolt-menu-layout__card"
              @click="$emit('select-product', product); selectedProduct = product"
            >
              <div class="wolt-menu-layout__card-text">
                <h3>{{ product.name }}</h3>
                <p v-if="product.description">{{ truncate(product.description) }}</p>
                <div class="wolt-menu-layout__card-price">{{ formatPrice(product.price) }}</div>
              </div>
              <div class="wolt-menu-layout__card-media">
                <img v-if="product.image_url" :src="product.image_url" :alt="product.name">
                <button type="button" class="wolt-menu-layout__add" aria-label="+">+</button>
              </div>
            </article>
          </div>
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import ProductOptionsPanel from './ProductOptionsPanel.vue'

export default {
  name: 'WoltMenuLayout',
  components: { ProductOptionsPanel },
  props: {
    categories: { type: Array, default: () => [] },
    currency: { type: String, default: 'RON' }
  },
  data () {
    return {
      activeCategoryId: null,
      selectedProduct: null
    }
  },
  watch: {
    categories: {
      immediate: true,
      handler (cats) {
        if (cats && cats.length) {
          this.activeCategoryId = cats[0].id
        }
        this.selectedProduct = null
      }
    }
  },
  methods: {
    selectCategory (id) {
      this.activeCategoryId = id
      this.$nextTick(() => {
        const el = document.getElementById('wolt-cat-' + id)
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    },
    truncate (text) {
      const s = String(text || '')
      return s.length > 90 ? s.slice(0, 87) + '...' : s
    },
    formatPrice (price) {
      const n = Number(price)
      if (Number.isNaN(n)) return ''
      return n.toFixed(2).replace('.', ',') + ' ' + this.currency
    }
  }
}
</script>

<style scoped>
.wolt-menu-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #f3f4f6;
}
.wolt-menu-layout__tabs {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  flex: 0 0 auto;
  z-index: 2;
}
.wolt-menu-layout__tab {
  border: 0;
  background: transparent;
  padding: 8px 14px;
  border-radius: 999px;
  white-space: nowrap;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
}
.wolt-menu-layout__tab.is-active {
  background: #cfe8ff;
  color: #0b4f8a;
}
.wolt-menu-layout__content {
  flex: 1 1 auto;
  min-height: 0;
  padding: 16px;
  overflow: auto;
}
.wolt-menu-layout__section h2 {
  margin: 8px 0 14px;
  font-size: 22px;
  font-weight: 800;
  text-transform: uppercase;
}
.wolt-menu-layout__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 28px;
}
@media (max-width: 1100px) {
  .wolt-menu-layout__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 700px) {
  .wolt-menu-layout__grid { grid-template-columns: 1fr; }
}
.wolt-menu-layout__card {
  display: flex;
  gap: 10px;
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  min-height: 120px;
}
.wolt-menu-layout__card-text {
  flex: 1;
  min-width: 0;
}
.wolt-menu-layout__card-text h3 {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 700;
}
.wolt-menu-layout__card-text p {
  margin: 0 0 8px;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.35;
}
.wolt-menu-layout__card-price {
  font-weight: 700;
}
.wolt-menu-layout__card-media {
  position: relative;
  width: 96px;
  flex: 0 0 96px;
}
.wolt-menu-layout__card-media img {
  width: 96px;
  height: 96px;
  object-fit: cover;
  border-radius: 10px;
  background: #e5e7eb;
}
.wolt-menu-layout__add {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 8px;
  background: #cfe8ff;
  color: #0b4f8a;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.wolt-menu-layout--product {
  display: block;
}
.wolt-menu-layout--product > * {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/MenuPreview/WoltMenuLayout.vue